<template>
  <div class="page">
    <div v-if="categoryIsLoad" class="category-main">
      <!-- 选择类目 -->
      <div class="category-item">
        <div class="category-key">选择类目:</div>
        <div class="category-val flex-column">
          <div class="category-input" @click="toggleCategory">
            <span>{{ categoryActiveStr }}</span>
            <el-link class="m-l-10" type="primary">
              {{ toggleStr }}
            </el-link>
          </div>
          <div v-show="isShowCategory" class="goods-category">
            <b-goods-category
              :ids="categoryRouteIds"
              :isInit="!categoryRouteIds.length"
              @success="getCategoryActiveList"
            />
          </div>
        </div>
      </div>

      <!-- 材质维护 -->
      <div v-if="categoryLastId" class="category-item">
        <div class="category-key">材质维护:</div>
        <div class="category-val">
          <ModuleCaizhi
            :list.sync="caizhiList"
            :obj="categoryLastActiveObj"
            @success="getModuleCaizhiList"
          />
        </div>
      </div>

      <!-- 计量属性维护 -->
      <div v-if="categoryLastId" class="category-item">
        <div class="category-key">计量属性维护:</div>
        <div class="category-val">
          <ModuleGuige
            :list.sync="guigeList"
            :obj="categoryLastActiveObj"
            @success="getModuleGuigeList"
          />
        </div>
      </div>

      <!-- 单位维护 -->
      <div v-if="categoryLastId" class="category-item">
        <div class="category-key">单位维护:</div>
        <div class="category-val">
          <ModuleUnit
            :list.sync="unitList"
            :guigeList="guigeList"
            :obj="categoryLastActiveObj"
            @success="getModuleUnitList"
          />
        </div>
      </div>

      <!-- 单位转换检测 -->
      <div v-if="categoryLastId" class="category-item">
        <div class="category-key">单位转换检测:</div>
        <div class="category-val">
          <ModuleTran
            :obj="categoryLastActiveObj"
            :caizhiList="caizhiList"
            :guigeList="guigeList"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleCaizhi from './common/module-caizhi'
import ModuleGuige from './common/module-guige'
import ModuleUnit from './common/module-unit'
import ModuleTran from './common/module-tran'
export default {
  components: {
    ModuleCaizhi,
    ModuleGuige,
    ModuleUnit,
    ModuleTran
  },
  data() {
    return {
      // 类目
      isShowCategory: false,
      categoryIsLoad: false,
      categoryLastId: '',
      categoryRouteIds: [],
      categoryActiveList: [],

      // 模块
      caizhiList: [], // 材质
      guigeList: [], // 规格
      unitList: [] // 单位
    }
  },
  computed: {
    // 类目末级选中对象
    categoryLastActiveObj() {
      let result = ''
      let len = this.categoryActiveList.length
      if (len) result = this.categoryActiveList[len - 1]
      return result
    },
    // 类目选中字符串
    categoryActiveStr() {
      let result = ''
      let listName = this.categoryActiveList.map((item) => item.name)
      result = listName.join('/')
      return result // 类目名称拼接成字符串
    },
    // 切换字符串
    toggleStr() {
      let result = this.isShowCategory ? '收起↑' : '展开↓'
      return result
    },
    // 提示字符串
    promptStr() {
      let result = `${this.categoryActiveStr}（点击${this.toggleStr}）`
      return result
    }
  },
  watch: {
    categoryLastActiveObj(newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        if (newVal.has_children) {
          this.categoryLastId = ''
        } else {
          this.categoryLastId = newVal.id
          this.isShowCategory = false
          this.$nextTick(() => {
            this.initModuleData()
          })
        }
      }
    }
  },
  mounted() {
    this.getCategoryRouteIds()
  },
  methods: {
    // 切换类目
    toggleCategory() {
      this.isShowCategory = !this.isShowCategory
    },
    // 获取路由类目ids
    getCategoryRouteIds() {
      this.categoryIsLoad = false
      let idsStr = this.$route.query.ids
      let idsList = []
      if (idsStr) idsList = idsStr.split(',')
      this.categoryRouteIds = idsList.map((item) => Number(item))
      this.categoryIsLoad = true
    },
    // 获取选中类目列表
    getCategoryActiveList(list) {
      this.categoryActiveList = []
      list.forEach((itemSt) => {
        itemSt.category.forEach((itemNd) => {
          if (itemSt.title.active_id === itemNd.id) {
            this.categoryActiveList.push(this.$util.deepCopy(itemNd))
          }
        })
      })
    },
    // 初始化模块数据
    initModuleData() {
      this.getModuleCaizhiList()
      this.getModuleGuigeList()
      this.getModuleUnitList()
    },
    // 获取模块-材质列表
    getModuleCaizhiList() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/midu/list',
        params: {
          id: this.categoryLastId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.caizhiList = res.data.list
        }
      })
    },
    // 获取模块-规格列表
    getModuleGuigeList() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/shuxing/list',
        params: {
          id: this.categoryLastId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.guigeList = res.data.list
        }
      })
    },
    // 获取模块-单位列表
    getModuleUnitList() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/columnDataJiSuanGongShi/list',
        params: {
          id: this.categoryLastId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.unitList = res.data.list
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 10px;
  .category-main {
    .category-item {
      display: flex;
      & ~ .category-item {
        margin-top: 5px;
      }
      .category-key {
        width: 107px;
        padding: 5px 5px 5px 0;
        line-height: 28px;
        text-align: right;
        background: #f8f8f9;
        border: 1px solid #e4e7ed;
        border-radius: 2px 0 0 2px;
      }
      .category-val {
        position: relative;
        min-width: 805px;
        padding: 5px;
        margin-left: -1px;
        border: 1px solid #e4e7ed;
        border-radius: 0px 2px 2px 0;
        .category-input {
          display: flex;
          align-items: center;
          width: 793px;
          height: 26px;
          padding: 0 5px;
          border: 1px solid #ddd;
          border-radius: 2px;
          cursor: pointer;
        }
        .goods-category {
          position: absolute;
          top: 32px;
          left: 5px;
          display: flex;
          z-index: 99;
        }
      }
    }
  }

  /deep/ .vxe-table--body-wrapper {
    min-height: 30px !important;
    max-height: 152px !important;
  }

  /deep/ .row--hover {
    background: @colorBlue10;
  }
}
</style>
